import React from 'react';

export const ErrorClinic = () => {
  return (
    <h1 className='text-white'>Invalid Clinic Identifier</h1>
  )
}